import React, { useState, useCallback } from 'react';
import { View, Text } from 'react-native'
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/pro-regular-svg-icons'
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { cardStyles as styles } from '../../Reports';
import { QUICKBOOKS_IMPORT } from './queries';
import { useMutation } from '@apollo/client';

const TransactionJournalImport = ({refetch}) => {
  const [date, setDate] = useState(
    moment().format('YYYY-MM-DD')
  );
  const [file, setFile] = useState();
  const [importing, setImporting] = useState(false);

  const [quickbooksImport] = useMutation(QUICKBOOKS_IMPORT, {
    onCompleted: () => {
      refetch();
      setImporting(false);
    }
  });

  const handleSubmit = () => {
    setImporting(true);
    let variables = {
      name: `Transaction Journal Import ${moment().format('MM-DD-YYYY h:mm:ss a')}`,
      ownerType: 'QuickbooksTransactionJournal',
      ownerId: 0,
      file: file,
    }
    quickbooksImport({ variables: variables });
  }

  const handleFiles = ({ target }) => {
    setFile(target.files[0])
  };

  return (
    <View style={{...styles.container, justifyContent: 'space-between'}}>
      <View>
        <Text style={styles.title}>Quickbooks Transaction Journal Import</Text>
        <input
          type="file"
          id='transaction-journal-input'
          onChange={e => handleFiles({ target: e.target })}
          style={{ display: 'none' }}
        />
        <label htmlFor='transaction-journal-input'>
          {`Quickbooks Transaction Journal Import File`}{' '}
          <FontAwesomeIcon icon={faPlusCircle} />
          <Text style={{marginLeft: '20px'}}>
            { file?.name }
          </Text>
        </label>
      </View>
      <View style={{justifyItems: 'flex-end'}}>
        <ButtonGroup>
          <Button
            label={importing ? "Importing..." : "Import"} onPress={() => handleSubmit()}
            disabled={!file || importing}
          />
        </ButtonGroup>
      </View>
    </View>
  )
}

export default TransactionJournalImport;
